import {
  SET_DOSSIERS,
  UPDATE_DOSSIER_STATUT,
  UPDATE_CONFIRMATION,
  SET_FILTERS,
  SET_CURRENT_DOSSIER,
  UPDATE_FORM_DATA,
  SET_CURRENT_RUBRIQUE,
  SET_CURRENT_PAGE,
  SET_PAGINATION,
  SET_DOSSIER_COMPLET,  // ← ajoute
  SET_DOSSIER_LOADING,
  API_PENDING_INC,
  API_PENDING_DEC,
} from "./actions";

// ─── Dossiers Reducer ───────────────────────────────────────────────────────
const dossiersInitialState = {
  list: [],
  currentDossier: null,
  filters: {
    search: "",
    statut: "tous",
    dateDebut: "",
    dateFin: "",
    confirmation: "tous",
  },

  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    total_pages: 1,
  },
};

const dossiersReducer = (state = dossiersInitialState, action) => {
  switch (action.type) {
    case SET_DOSSIERS:
      return { ...state, list: action.payload };

    case UPDATE_DOSSIER_STATUT:
      return {
        ...state,
        list: state.list.map((d) =>
          d.id === action.payload.id
            ? { ...d, statut: action.payload.statut }
            : d
        ),
      };

    case UPDATE_CONFIRMATION:
      return {
        ...state,
        list: state.list.map((d) =>
          d.id === action.payload.id
            ? { ...d, etat_confirmation: action.payload.etat_confirmation }
            : d
        ),
      };

    case SET_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };

    case SET_CURRENT_DOSSIER:
      return { ...state, currentDossier: action.payload };
    
    case SET_PAGINATION:
      return { ...state, pagination: action.payload };

    default:
      return state;
  }
};

// ─── Formulaires Reducer ─────────────────────────────────────────────────────
const formulairesInitialState = {
  loading: false,        // ← ajoute
  currentRubrique: 0,
  currentPage: 0,
  data: {},
};

const formulairesReducer = (state = formulairesInitialState, action) => {
  switch (action.type) {
    case SET_CURRENT_RUBRIQUE:
      return { ...state, currentRubrique: action.payload, currentPage: 0 };

    case SET_CURRENT_PAGE:
      return { ...state, currentPage: action.payload };

    case UPDATE_FORM_DATA: {
      const { dossierId, rubrique, sousRubrique, values } = action.payload;
      return {
        ...state,
        data: {
          ...state.data,
          [dossierId]: {
            ...(state.data[dossierId] || {}),
            [rubrique]: {
              ...((state.data[dossierId] || {})[rubrique] || {}),
              [sousRubrique]: typeof values === "string"
                ? values
                : Array.isArray(values)
                ? values
                : {
                    ...(((state.data[dossierId] || {})[rubrique] || {})[sousRubrique] || {}),
                    ...values,
                  },
            },
          },
        },
      };
    }

    case SET_DOSSIER_LOADING:
      return { ...state, loading: action.payload };

    case SET_DOSSIER_COMPLET: {
      const { id, data, source } = action.payload;
      const formulaires = {};

      const normalizeValues = (obj) => {
        if (obj === null || obj === undefined) return obj;
        if (typeof obj === "string") {
          if (obj.length <= 20) {
            return obj.toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");
          }
          return obj;
        }
        if (Array.isArray(obj)) return obj.map(normalizeValues);
        if (typeof obj === "object") {
          return Object.fromEntries(
            Object.entries(obj).map(([k, v]) => [k, normalizeValues(v)])
          );
        }
        return obj;
      };

      const rubriques = [
        "infos_enfant",
        "infos_generales",
        "infos_references",
        "observations_malade",
        "cartographie_sites",
        "resultats_bilan",
        "conclusion_cartographie_site",
        "decision_therapeutique",
        "evaluation_pathologie",
        "traitement_deuxieme_ligne",
        "premiere_hospitalisation",
        "nouvelle_hospitalisation",
        "dernieres_nouvelles",
        "courbe_croissance",
        "pages_annexes",
        "examens_medicaux"

      ];

      rubriques.forEach((rubrique) => {
        if (data[rubrique]) {
          const { images, ...rest } = data[rubrique];
          formulaires[rubrique] = { ...normalizeValues(rest), images };
        }
      });

      return {
        ...state,
        data: {
          ...state.data,
          [id]: {
            ...formulaires,
            _source: source || null,
          },
        },
      };
    }

    default:
      return state;
  }
};



// ─── UI Reducer (compteur de requêtes en cours → loader global) ──────────────
const uiInitialState = { pending: 0 };

const uiReducer = (state = uiInitialState, action) => {
  switch (action.type) {
    case API_PENDING_INC:
      return { ...state, pending: state.pending + 1 };
    case API_PENDING_DEC:
      return { ...state, pending: Math.max(0, state.pending - 1) };
    default:
      return state;
  }
};

export { dossiersReducer, formulairesReducer, uiReducer };